export const Auth0Config = {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  client_id: process.env.VUE_APP_AUTH0_CLIENT_ID,
  connection: process.env.VUE_APP_AUTH0_CONNECTION,
  redirect_uri: `${process.env.VUE_APP_BASE_URL}/auth/login/redirect`,
  logout_redirect_uri: `${process.env.VUE_APP_BASE_URL}/auth/logout/redirect`,
};
